const useTSHacks = () => {
    const getObjectProperty = (object: any, propertyName: string) => {
        // @ts-ignore
        return object[propertyName]
    }

    const setObjectProperty = (object: any, propertyName: string, value: any) => {
        // @ts-ignore
        object[propertyName] = value 
    }
    return {
        getObjectProperty,
        setObjectProperty
    }
}

export default useTSHacks